import { createGlobalStyle } from 'styled-components'
import theme from './theme'
import FontFaces from './fonts'

const { fonts, colors } = theme

const GlobalStyle = createGlobalStyle `

  ${FontFaces};

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    border: 0;
    font: inherit;
    font-size: 100%;
    margin: 0;
    padding: 0;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  ol, ul {
    list-style: none;
  }
  * {
    box-sizing: border-box;
  }
  a {
    text-decoration: none !important;
    color: ${colors.secondary};
  }
  a:hover {
    text-decoration: initial;
    color: ${colors.primary};
  }
  button {
    background: none;
    border: 0;
    padding: 0;
  }
  img {
    display: block;
    width: 100%;
    height: auto;
  }
  svg {
    fill: currentColor;
  }
  .small,
  small {
    font-size: .8em;
  }
  html {
    font-size: 10px;
    -moz-osx-font-smoothing: antialiased;
    -webkit-font-smoothing: antialiased;
  }
  i, em {
    font-style: italic;
  }
  b {
    font-weight: 700;
  }

  body {
    font-family: ${fonts.RobotoSlab};
    font-weight: 400;
    font-style: normal;
    text-rendering: optimizeLegibility;
    background: ${colors.background};
  }
  
  @media (prefers-reduced-motion: reduce) {
    * {
      animation: none;
      transition: none;
    }
  }
` 

export default GlobalStyle
